import { Spin } from 'antd'
import React from 'react'
 
function Loading(){
	return(	
		  <div className='loader'><Spin tip="Loading"></Spin></div>
		);
}

export default Loading;